import React, { useState, useEffect } from 'react'
import { formatResumeData, formatStudentData } from './utils'
import { resumeBulkDownload, resumeBulkDownloadJobRoles } from 'modules/Drives/actions'
import { singlePdf } from 'utils/downloadFile'
import ErrorMessage from 'utils/ErrorMessage'

const RESUME_DOWNLOAD_ERROR = 'Unable to download the resume. Please try again.'

const ResumeDownload = ({ triggerButton, studentDetails, roleId }) => {
  const [formattedData, setFormattedData] = useState(null)
  const [isDownloading, setIsDownloading] = useState(false)

  useEffect(() => {
    const formatData = async () => {
      try {
        const studentData = await formatStudentData(studentDetails)
        const formattedResumeData = await formatResumeData(studentData)
        setFormattedData(formattedResumeData)
      } catch (error) {
        console.error('Error formatting resume data:', error)
      }
    }

    formatData()
  }, [studentDetails])

  const callBulkDownloadApi = async () => {
    if (isDownloading) return
    setIsDownloading(true)
    
    const payload = {
      email: formattedData?.student?.email || "",
      instName: studentDetails?.instituteCampusName || "",
      state: formattedData?.student?.state || "",
      city: formattedData?.student?.city || "",
      user: formattedData?.student?.fullName || "",
      studentIds: [[studentDetails?.id]],
      roleId: roleId
    }

    try {
      const response = roleId
        ? await resumeBulkDownloadJobRoles({ ...payload, roleId: roleId })()
        : await resumeBulkDownload(payload)()

      // These actions resolve with { error, errorMessage } rather than throwing,
      // so a failure has to be caught here — otherwise singlePdf would wrap the
      // error body in a Blob and "download" a corrupt file. The common case is
      // the 422 raised when this candidate has no uploaded CV for the role.
      if (response?.error) {
        ErrorMessage(response.errorMessage || RESUME_DOWNLOAD_ERROR)
        return
      }

      await singlePdf(response, formattedData?.student?.fullName || 'Resume', studentDetails?.id)
    } catch (e) {
      console.error('Bulk resume download API error:', e)
      ErrorMessage(RESUME_DOWNLOAD_ERROR)
    } finally {
      setIsDownloading(false)
    }
  }

  const handleClick = () => {
    if (formattedData) {
      callBulkDownloadApi()
    }
  }

  return (
    <span onClick={handleClick} style={{ cursor: isDownloading ? 'wait' : 'pointer' }}>
      {isDownloading ? 'Downloading...' : triggerButton}
    </span>
  )
}

export default ResumeDownload
